module.exports = __webpack_public_path__ + "static/Pricing-1b0e058cd9f334a9c26afa808df06a4c.png";